import { Link, useParams, useSearchParams } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { user } from "../../routes/route";
import { IconButton, Paper, useScrollTrigger } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { useNavigate } from "react-router-dom";
import DashboardAnalytics from "./DashboardAnalytics";
import UserMeditationHistory from "./meditation/UserMeditationHistory";
import { userMeditationHistoryApi } from "../../services/meditationManagement";
import moment from "moment";
import { IoSearch } from "react-icons/io5";
import { DatePicker } from "../../components/Form";
import { SecondaryButton } from "../../components/Button/Button";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import { dateFormatUtc } from "../../utils/dateFormat";
import Loader from "../../comman/Loader";


const MeditationDashboard = () => {
  const navigate = useNavigate();
  const [searchParam, setSearchParam] = useSearchParams();
  let activePage = +searchParam.get("page") || 1;
  const [orderList, setOrderList] = useState([]);
  const [total, setTotal] = useState(null);
  const[loading, setLoading] = useState(false);

    // Filter states
    const [search, setSearch] = useState(searchParam.get("search") || "");
   
    const startDate = searchParam.get("startDate") ? searchParam.get("startDate") : null;
    const endDate = searchParam.get("endDate") ? searchParam.get("endDate") : null;

    const timeOfDay = searchParam.get("timeOfDay") || "";
    const meditationType = searchParam.get("meditationType") || "";
 

  // handle all hooks
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  // handle all function

 

 

  //*********Handel Pagination********* */


  useEffect(() => {
    fetchUserMeditationHistory();
  }, [activePage]); // Ensure data updates when page changes
  

  // Fetch Consultant order history
  const fetchUserMeditationHistory = async () => {
    try {
      setLoading(true);
      const params = {
        page:  `${activePage}`,
       limit: '10',
       filter:{}
      };
      console.log("startDate", startDate);
      console.log("endDate", endDate);

      if(search){
        params.search = search.trim();
      }
      if(startDate){
        params.filter.startDate = startDate;
      }
      if(endDate){
        params.filter.endDate = endDate;
      }
     
      if(timeOfDay){
        params.filter.timeOfDay = timeOfDay.trim();
      }
      if(meditationType){
        params.filter.meditationType = meditationType.trim();
      }
      
      console.log("API params:", params); // Debug log
      const { data } = await userMeditationHistoryApi(params);
      console.log("API response:", data); // Debug log
      if (data.code === 200) {
        setOrderList(data?.result?.list || []);
        setTotal(data?.result?.total || 0);
      } else {
        setOrderList([]);
        setTotal(0);
      }
    } catch (error) {
      console.error("Error fetching meditation history:", error);
      setOrderList([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  };


 

  useEffect(() => {
    fetchUserMeditationHistory();
  }, []);

  useEffect(() => {
    fetchUserMeditationHistory();
  }, [activePage, search, startDate, endDate, timeOfDay, meditationType]);

  
  useEffect(() => {
    if (Number(activePage) === 1) {
      searchParam.delete("page");
    }
    console.log("searchParamuseEffect", searchParam,activePage);
    setSearchParam(searchParam);
    fetchUserMeditationHistory();
  }, [searchParam]);

 
  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      navigate(-1);
    } else {
      navigate("/default-route"); // Fallback route
    }
  };
  
  

  const handlePageChange = (page) => {
    searchParam.set("page", page);
    setSearchParam(searchParam);
  };

  // Handle filter changes
  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    searchParam.delete("page");
    searchParam.set("search", e.target.value);
    setSearchParam(searchParam);
  };

  const handleStartDateChange = (date) => {
    const utcDateString = dateFormatUtc(date);
    console.log("utcDateString", utcDateString);
    searchParam.delete("page");
    searchParam.set("startDate", utcDateString);
    setSearchParam(searchParam);
  };

  const handleEndDateChange = (date) => {
    const utcDateString = dateFormatUtc(date);
    console.log("utcDateString", utcDateString);
    searchParam.delete("page");
    searchParam.set("endDate", utcDateString);
    setSearchParam(searchParam);
   
  };

  const handleTimeOfDayChange = (e) => {
    searchParam.delete("page");
    searchParam.set("timeOfDay", e.target.value);
    setSearchParam(searchParam);
  };

  const handleTypeChange = (e) => {
    searchParam.delete("page");
    searchParam.set("meditationType", e.target.value);
    setSearchParam(searchParam);
  };

  // Reset filters
  const handleResetFilters = () => {
    setSearch("");
    searchParam.delete("page");
    searchParam.delete("startDate");
    searchParam.delete("endDate");
    searchParam.delete("timeOfDay");
    searchParam.delete("meditationType");
    setSearchParam(searchParam);
  };

  // Fetch data when filters or page change


  return (
    <>
      <div className="WrapperArea">
        <div className="WrapperBox">
          
          <div className="TitleBox">
            <div className="user_detail_heading">
              {/* <h4 className="Title">User Management</h4> */}
              {/* <Link className="back_icon" to={`/consultant-management/${consultant._id}`}> */}
              <IconButton onClick={handleBack}>
                <ArrowBackIosNewIcon className="back_button" />
              </IconButton>
              {/* </Link> */}
              <h4 className="Title">Meditation Dashboard {loader}</h4>
            </div>
            
          </div>
    
          <DashboardAnalytics />
         
          <div className="FilterBox FilterArea consultant-header my-4">
            <div className="form-group search_lg_size userSearch">
              <input
                type="search"
                className={`form-control ${search && "active"}`}
                placeholder="Search"
                value={search}
                onChange={(e) => handleSearchChange(e)}
                style={{ "--color": "#FF8989" }}
              />
              <span className="user_search_icon">
                <IoSearch />
              </span>
            </div>
            <div className="group_filter_value d-flex align-items-center gap-3 flex-wrap">
              <div className="form-group date_picker">
                <DatePicker
                  className={`form-control ${startDate && "active"}`}
                  name="startDate"
                  selected={startDate}
                  placeholderText="Start Date"
                  onChange={(date) => handleStartDateChange(date)}
                  maxDate={new Date()}
                  isClearable
                />
              </div>
              <div className="form-group date_picker">
                <DatePicker
                  className={`form-control ${endDate && "active"}`}
                  name="endDate"
                  selected={endDate}
                  placeholderText="End Date"
                  onChange={(date) => handleEndDateChange(date)}
                  maxDate={new Date()}
                  isClearable
                />
              </div>
              <div className="form-group select_sm_width">
                <select
                  className={`form-control ${timeOfDay && "active"}`}
                  value={timeOfDay}
                  onChange={(e) => handleTimeOfDayChange(e) }
                >
                  <option value="">Time of Day</option>
                  <option value="morning">Morning (00:AM - 11:59PM)</option>
                  <option value="afternoon">Afternoon (12:00PM - 05:59PM)</option>
                  <option value="evening">Evening (06:00PM - 11:59PM)</option>
                  <option value="night">Night (12:00AM - 05:59AM)</option>
                </select>
              </div>
              <div className="form-group select_sm_width">
                <select
                  className={`form-control ${meditationType && "active"}`}
                  value={meditationType}
                  onChange={(e) => handleTypeChange(e)}
                >
                  <option value="">Meditation Type</option>
                  <option value="Music">Music</option>
                  <option value="Mantra">Mantra</option>
                </select>
              </div>
              <div className="form-group refresh_button">
                <SecondaryButton onClick={handleResetFilters}>
                  <RotateLeftIcon />
                </SecondaryButton>
              </div>
            </div>
          </div>
          <div className="mt-3">
            <h5>User Meditation History</h5>
            <div>
              {loading ? <Loader /> :
              <UserMeditationHistory
                handlePageChange={handlePageChange}
                orderList={orderList}
                activePage={activePage}
                total={total}
              />
              }
            </div>
          </div>
        </div>
      </div>
   
    
    </>
  );
};
export default MeditationDashboard;
